import React from "react";
import { Pressable, ScrollView, Text, View } from "react-native";

import {
  AI_EXHIBIT_COLORS as C,
  AI_EXHIBIT_MAX_WIDTH,
} from "./aiExhibitTheme";

function ShellButton({
  label,
  onPress,
  disabled = false,
  active = false,
}) {
  return (
    <Pressable
      onPress={disabled ? undefined : onPress}
      accessibilityRole="button"
      disabled={disabled}
      style={({ pressed }) => ({
        minHeight: 50,
        minWidth: 92,
        paddingHorizontal: 15,
        paddingVertical: 12,
        borderRadius: 14,
        borderWidth: 1,
        borderColor: active ? C.accent : C.border,
        backgroundColor:
          active || pressed ? C.accentSoft : C.surfaceRaised,
        opacity: disabled ? 0.45 : 1,
        alignItems: "center",
        justifyContent: "center",
      })}
    >
      <Text
        style={{
          color: C.text,
          fontSize: 15,
          fontWeight: "800",
        }}
      >
        {label}
      </Text>
    </Pressable>
  );
}

export default function AIExhibitShell({
  children,
  screenId,
  copy,
  canGoBack,
  onBack,
  onHome,
  onSources,
  onToggleLanguage,
  audioEnabled,
  onToggleAudio,
}) {
  const showChrome = screenId !== "attract";

  return (
    <View
      style={{
        height: "100vh",
        width: "100%",
        backgroundColor: C.background,
        overflow: "hidden",
      }}
    >
      {showChrome ? (
        <View
          style={{
            flexShrink: 0,
            borderBottomWidth: 1,
            borderBottomColor: C.border,
            backgroundColor: C.surface,
          }}
        >
          <View
            style={{
              width: "100%",
              maxWidth: AI_EXHIBIT_MAX_WIDTH,
              alignSelf: "center",
              paddingHorizontal: 24,
              paddingVertical: 14,
              gap: 12,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            <Text
              style={{
                color: C.text,
                fontSize: 18,
                fontWeight: "900",
                flexShrink: 1,
              }}
            >
              {copy.exhibitTitle}
            </Text>

            <View
              style={{
                flexDirection: "row",
                gap: 8,
                flexWrap: "wrap",
              }}
            >
              <ShellButton
                label={`← ${copy.back}`}
                onPress={onBack}
                disabled={!canGoBack}
              />
              <ShellButton
                label={`⌂ ${copy.home}`}
                onPress={onHome}
              />
              <ShellButton
                label="Sources"
                onPress={onSources}
                active={screenId === "sources"}
              />
              <ShellButton
                label={
                  audioEnabled
                    ? `🔊 ${copy.audioOn}`
                    : `🔊 ${copy.audio}`
                }
                onPress={onToggleAudio}
                active={audioEnabled}
              />
              <ShellButton
                label={copy.language}
                onPress={onToggleLanguage}
              />
            </View>
          </View>
        </View>
      ) : null}

      <ScrollView
        style={{
          flex: 1,
          width: "100%",
        }}
        contentContainerStyle={{
          flexGrow: 1,
          width: "100%",
          maxWidth: AI_EXHIBIT_MAX_WIDTH,
          alignSelf: "center",
          paddingBottom: showChrome ? 34 : 0,
        }}
        showsVerticalScrollIndicator
        keyboardShouldPersistTaps="handled"
      >
        {children}
      </ScrollView>
    </View>
  );
}
